var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox"},[_c('label',[_vm._t("default"),_vm._v(" "+_vm._s(_vm.label)+"\n        "),_vm._t("description")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }